/**
 * @generated SignedSource<<329028356eacbcb03dcfa8a3a24e1dc5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationStatusType = "APPROVED" | "PENDING" | "%future added value";
export type IntegrationType = "AWS" | "BITBUCKET" | "BUILDKITE" | "CAPABILITIES" | "CLOUDWATCH" | "CONFLUENCE" | "CURSOR" | "DATADOG" | "DEVIN" | "DISCORD" | "ELASTICSEARCH" | "FIREHYDRANT" | "GCP" | "GCP_CLOUD_MONITORING" | "GITHUB" | "GITLAB" | "GRAFANA_CLOUD" | "INCIDENT_IO" | "JIRA" | "LANGFUSE" | "LANGSMITH" | "LINEAR" | "NEW_RELIC" | "NOTION" | "OPENSEARCH" | "OPSGENIE" | "PAGERDUTY" | "PGANALYZE" | "POSTGRESQL" | "PROMETHEUS" | "ROLLBAR" | "ROOTLY" | "SENTRY" | "SLACK" | "SNOWFLAKE" | "SOCKET" | "TEMPORAL" | "%future added value";
export type BitbucketIntegrationsDialogQuery$variables = Record<PropertyKey, never>;
export type BitbucketIntegrationsDialogQuery$data = {
  readonly me: {
    readonly organization: {
      readonly integrations: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly bitbucketUsername: string | null | undefined;
            readonly bitbucketWorkspaceSlugs: ReadonlyArray<string> | null | undefined;
            readonly createdAt: any;
            readonly id: any;
            readonly integrationStatus: IntegrationStatusType | null | undefined;
            readonly integrationType: IntegrationType;
            readonly name: string;
          };
        }>;
      };
    };
    readonly " $fragmentSpreads": FragmentRefs<"appMe">;
  };
};
export type BitbucketIntegrationsDialogQuery = {
  response: BitbucketIntegrationsDialogQuery$data;
  variables: BitbucketIntegrationsDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "integrationType",
      "value": "BITBUCKET"
    }
  ],
  "concreteType": "GraphQLIntegrationConnection",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLIntegrationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLIntegration",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "integrationType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "integrationStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bitbucketUsername",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bitbucketWorkspaceSlugs",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "integrations(integrationType:\"BITBUCKET\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "BitbucketIntegrationsDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLUser",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "appMe"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLOrganization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "BitbucketIntegrationsDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLUser",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pictureUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSuperAdmin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scopes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLOrganization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "brandTheme",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSuspended",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "suspensionReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "suspendedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "creditLimitResetAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appUrlDomain",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "onboardingCompletedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabledFeatureFlags",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLUserTeamContext",
            "kind": "LinkedField",
            "name": "teamContext",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLTeam",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "30a40cef6a5d70ca1f4119e7dfcc2261",
    "id": null,
    "metadata": {},
    "name": "BitbucketIntegrationsDialogQuery",
    "operationKind": "query",
    "text": "query BitbucketIntegrationsDialogQuery {\n  me {\n    ...appMe\n    organization {\n      integrations(integrationType: BITBUCKET) {\n        edges {\n          node {\n            id\n            name\n            integrationType\n            integrationStatus\n            createdAt\n            bitbucketUsername\n            bitbucketWorkspaceSlugs\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment appMe on GraphQLUser {\n  id\n  email\n  firstName\n  lastName\n  pictureUrl\n  isSuperAdmin\n  role\n  scopes\n  organization {\n    id\n    name\n    brandTheme\n    isSuspended\n    suspensionReason\n    suspendedAt\n    creditLimitResetAt\n    appUrlDomain\n    onboardingCompletedAt\n    enabledFeatureFlags\n  }\n  teamContext {\n    id\n    team {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c99949b18d6696c622ba1ae4967e99b5";

export default node;
